import React from 'react';

function ShareVideoEmailTemplate(props) {

  const style = {
    body: {
      fontFamily: 'arial',
      fontSize: '14px'
    },
    msg: {
      width: '90%',
      margin: '5%',
      background: '#f6f6f6',
      borderRadius: '4px',
      padding: '10px',
    },
    img: {
      marginBottom: '50px'
    },
    p: {
      paddingLeft: '10px'
    },

    btn: {
      marginLeft: "20px",
      background: "#5f1daf",
      color: "#fff",
      padding: "5px 10px",
      borderRadius: "4px",
      textDecoration: "none!important"
    },
    footer: {
      marginTop: "20px",
      paddingTop: "20px"
    },
    hdr: {
      color: "#333333",
      backgroundImage: 'url("https://www.sitesupt.com/favicon.png")',
      backgroundRepeat: "no-repeat",
      backgroundSize: "30px 30px",
      lineHeight: "30px",
      paddingLeft: "40px",
      marginBottom: "30px"
    }
  }
  return (<React.Fragment>
    <div style={style.msg}>
      <div style={style.hdr}><b>SITEKICK</b></div>
      <div>
        Hi, <p style={style.p}>
          <b>Location:</b> {props.location_name} <br />
          <b>Date Time:</b> {props.timestamp} <br /><br />
          Click the button below to play the video.</p><a style={style.btn} href={props.video_url}>Open Video</a>
        <div style={style.footer}>
          Thanks,<br />
          {props.user_name}
        </div>
      </div>
    </div>
  </React.Fragment>)
}

export default ShareVideoEmailTemplate;